import { custom, success } from "./utilities";
import { projectConstants, globalConstants } from "../../constants";
import { projectService } from "../../services/project.services";
import { ToastifyService } from "../../services/toastify.services";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: null,
  search: null,
  filterExpression: globalConstants.FILTER_EXPRESSION,
};

export const getAllProject = (gridState, id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    projectService
      .getAll(gridState, id)
      .then((response) => {
        dispatch(success(response, projectConstants.GET_PROJECTS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getProjectById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    projectService
      .getById(id)
      .then((response) => {
        console.log("response", response);
        dispatch(success(response, projectConstants.GET_PROJECT_BY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deleteProjectById = (id,companyId) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    projectService
      .deleteById(id)
      .then((response) => {
        dispatch(getAllProject(gridData, companyId));
        ToastifyService.showSuccess("Status Updated Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const createProject = (data, companyId, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    projectService
      .create(data)
      .then((response) => {
        dispatch(getAllProject(gridData, companyId));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateProject = (data, companyId, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    projectService
      .update(data)
      .then((response) => {
        dispatch(getAllProject(gridData, companyId));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllProjectList = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    projectService
      .getAllProjectList()
      .then((response) => {
        dispatch(success(response.items, projectConstants.GET_PROJECT_LIST));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllProjectListWithIsActive = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    projectService
      .getAllProjectListWithIsActive()
      .then((response) => {
        dispatch(success(response.items, projectConstants.GET_PROJECT_LIST));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const projectActions = {
  getAllProject,
  getProjectById,
  deleteProjectById,
  createProject,
  updateProject,
  getAllProjectList,
  getAllProjectListWithIsActive
};
